import { Actualizador } from "./Actualizador";
import { InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "@shared/states";
import { AccionEnum } from "@shared/enums";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";
import { firstValueFrom } from "rxjs";

export class FunnelActualizador extends Actualizador {
    constructor(private investigacionesService: InvestigacionesService) {
        super();
        this.modificarEstado = (state, investigacion, datos) => {
            switch (datos.datosFunnels!.accion) {
            case AccionEnum.AGREGAR:
                state.funnelsInvestigacionSeleccionada = [
                    datos.datosFunnels!.funnel, ...state.funnelsInvestigacionSeleccionada!
                ];
                break;
            case AccionEnum.BORRAR:
                state.funnelsInvestigacionSeleccionada = state.funnelsInvestigacionSeleccionada!
                    .filter(funnel => funnel.id === datos.datosFunnels!.funnel.id);
                break;
            }
        };
    }

    async actualizar(investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion): Promise<InvestigacionDTO> {
        const clonInvestigacion = investigacion.clon();
        switch (datos.datosFunnels!.accion) {
        case AccionEnum.AGREGAR:
            await firstValueFrom(
                this.investigacionesService.agregarFunnel(
                    clonInvestigacion, datos.datosFunnels!.envio, datos.datosFunnels!.funnel
                )
            );
            break;
        case AccionEnum.BORRAR:
            await firstValueFrom(
                this.investigacionesService.borrarFunnel(
                    clonInvestigacion, datos.datosFunnels!.envio, datos.datosFunnels!.funnel
                )
            );
            break;
        }
        return clonInvestigacion;
    }

    esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosFunnels != null;
    }

}
